import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export function WithLocalization<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Child {...props} />
    </LocalizationProvider>
  );
}
